import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "value", "onChange"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import TextInput from 'components/TextInput';
function AlternativeTextField(_ref) {
  var isDisabled = _ref.isDisabled,
    value = _ref.value,
    onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FormField, _extends({
    label: t('form_alternative_text'),
    descriptionType: "tooltip",
    description: t('form_alternative_text_info')
  }, otherProps), /*#__PURE__*/React.createElement(TextInput, {
    value: value,
    onChange: onChange,
    disabled: isDisabled
  }));
}
export default AlternativeTextField;